/* ═══════════════════════════════════════════════════════════════════════
   TWS — UTM PERSISTENCE
   The user, 7 Aug 2026: "when user comes to lets say anthology process page
   the utm links are intact but once they go to submit sample page the utm is
   lost, i want that they remain intact."

   ⚠⚠ NO FORM APP FIXES THIS, AND THAT IS THE WHOLE POINT.
   Every app's "UTM tracking" feature reads the UTM parameters off the URL of
   the page the FORM is on. A visitor lands on
       /pages/anthologies?utm_source=meta&utm_campaign=antho-jul
   clicks "Submit a sample", and arrives at /pages/sample-submission with a
   bare URL. The app looks for UTMs, finds none, and records the submission as
   direct traffic. Buying the Pro plan does not change that.

   The fix has to happen BEFORE the form: capture the parameters the moment the
   visitor lands anywhere on the site, keep them for the session, and write them
   into every form as hidden fields. That is what this file does, and it works
   with ANY form app that supports hidden fields (Hulk, Qikify, Shopify Forms),
   as well as with the static forms we built.

   ⚠ THIS IS ALSO WHY THE AWARD PAGE WAS MERGED INTO ONE URL. With this script
   in place that merge was not strictly necessary — but it stays merged; the
   single page is better for other reasons.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__twsUTM) return;

  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
              'gclid', 'fbclid', 'ttclid', 'msclkid'];
  var STORE = 'tws_attr';
  var COOKIE_DAYS = 30;

  function read(name) {
    try {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) { return ''; }
  }
  function write(name, value, days) {
    try {
      var d = new Date(); d.setTime(d.getTime() + days * 864e5);
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }
  function load() {
    try {
      var s = sessionStorage.getItem(STORE);
      if (s) return JSON.parse(s);
    } catch (e) {}
    var c = read(STORE);
    if (c) { try { return JSON.parse(c); } catch (e) {} }
    return null;
  }
  function save(o) {
    var s = JSON.stringify(o);
    try { sessionStorage.setItem(STORE, s); } catch (e) {}
    write(STORE, s, COOKIE_DAYS);
  }

  /* ── CHANNEL, FOR EVERYTHING THAT IS NOT A TAGGED AD ──────────────────
     The user, 7 Aug: "is there a way that i get to know what traffic comes
     from other channels apart from direct, like google, instagram, facebook,
     linkedin, newsletter".

     UTMs only exist if whoever made the link added them. An Instagram bio tap,
     a Google result, a shared WhatsApp link — none carry UTMs, and every one of
     those lands in "direct" unless something else identifies it. The referrer
     does, so it is classified here and travels with the submission exactly like
     the UTMs do.

     ⚠ PRECEDENCE MATTERS. A real utm_medium always wins — if the marketing team
     tagged the link, their label is the truth, not our guess at the referrer. */
  var SOCIAL = {
    'facebook': 'Facebook', 'fb': 'Facebook', 'instagram': 'Instagram',
    'threads': 'Threads', 'linkedin': 'LinkedIn', 'lnkd': 'LinkedIn',
    'twitter': 'X/Twitter', 'x': 'X/Twitter', 't': 'X/Twitter',
    'tiktok': 'TikTok', 'youtube': 'YouTube', 'youtu': 'YouTube',
    'pinterest': 'Pinterest', 'reddit': 'Reddit', 'whatsapp': 'WhatsApp',
    'wa': 'WhatsApp', 'telegram': 'Telegram', 'snapchat': 'Snapchat'
  };
  var SEARCH = { 'google': 'Google', 'bing': 'Bing', 'duckduckgo': 'DuckDuckGo',
                 'yahoo': 'Yahoo', 'ecosia': 'Ecosia', 'brave': 'Brave', 'yandex': 'Yandex' };
  var MAIL = { 'mail': 'Webmail', 'outlook': 'Outlook', 'gmail': 'Gmail' };
  var AI = { 'chatgpt': 'ChatGPT', 'openai': 'ChatGPT', 'perplexity': 'Perplexity',
             'claude': 'Claude', 'gemini': 'Gemini', 'copilot': 'Copilot' };

  function host(u) {
    try { return new URL(u).hostname.replace(/^www\./, '').toLowerCase(); }
    catch (e) { return ''; }
  }
  /* second-to-last label: "l.instagram.com" -> instagram, "co.uk" handled by
     falling back one more label when the tail is a 2-letter country code */
  function brand(h) {
    var p = h.split('.');
    if (p.length < 2) return h;
    var i = p.length - 2;
    if (p[p.length - 1].length === 2 && p.length > 2 && p[i].length <= 3) i = p.length - 3;
    return p[i];
  }

  function classify(ref, d) {
    var out = { channel: 'direct', source_detail: '' };
    var med = (d.utm_medium || '').toLowerCase();
    var src = (d.utm_source || '').toLowerCase();

    if (med || src) {
      out.source_detail = d.utm_source || d.utm_medium;
      if (/cpc|ppc|paid|cpm|paidsocial|paid_social/.test(med)) out.channel = 'paid';
      else if (/email|newsletter|mail/.test(med) || /newsletter|klaviyo|mailchimp/.test(src)) out.channel = 'email';
      else if (/social/.test(med) || SOCIAL[src]) out.channel = 'social';
      else if (/organic|seo/.test(med)) out.channel = 'organic_search';
      else if (/affiliate|referral/.test(med)) out.channel = 'referral';
      else out.channel = 'campaign';
      return out;
    }
    /* a click id with no UTMs is still unambiguously a paid click */
    if (d.gclid) { return { channel: 'paid', source_detail: 'Google Ads' }; }
    if (d.fbclid) { return { channel: 'paid', source_detail: 'Meta Ads' }; }
    if (d.ttclid) { return { channel: 'paid', source_detail: 'TikTok Ads' }; }
    if (d.msclkid) { return { channel: 'paid', source_detail: 'Microsoft Ads' }; }

    var h = host(ref);
    if (!h) return out;                                   // no referrer => direct
    if (h === location.hostname.replace(/^www\./, '')) return { channel: 'internal', source_detail: h };
    var b = brand(h);
    /* ⚠ WEBMAIL MUST BE TESTED BEFORE SEARCH. `brand('mail.google.com')` is
       "google", so a click from Gmail was being filed as organic Google search —
       measured, not theorised. The subdomain is the only thing that separates
       them, so match the whole host first. */
    if (/^mail\.|^webmail\.|^inbox\./.test(h) || /outlook|zoho|proton|yandex\.mail/.test(h)) {
      return { channel: 'email', source_detail: /google/.test(h) ? 'Gmail' : (MAIL[b] || h) };
    }
    if (SEARCH[b]) return { channel: 'organic_search', source_detail: SEARCH[b] };
    if (SOCIAL[b]) return { channel: 'social', source_detail: SOCIAL[b] };
    if (AI[b])     return { channel: 'ai_assistant', source_detail: AI[b] };
    if (MAIL[b])   return { channel: 'email', source_detail: MAIL[b] };
    return { channel: 'referral', source_detail: h };
  }

  /* exported so the classification can be tested without faking a referrer */
  window.twsClassify = classify;


  /* LAST TOUCH WINS. If this page's URL carries UTMs the visitor has just
     clicked a NEW ad, so that campaign replaces whatever was stored — an old
     session's campaign must never be credited with a fresh click. Otherwise
     keep what we already have. */
  var q, fresh = {}, any = false;
  try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  if (q) {
    KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v) { fresh[k] = v; any = true; }
    });
  }

  var stored = load();
  var data = stored || {};

  /* ⚠ A NEW VISIT IS NOT ONLY A NEW UTM. Without the second half of this test,
     someone who arrives from Google (no UTMs) after an earlier tagged ad visit
     is still credited to that ad, because sessionStorage survives. An EXTERNAL
     referrer with no stored campaign is a fresh visit and must be recorded. */
  var ext = document.referrer && host(document.referrer) &&
            host(document.referrer) !== location.hostname.replace(/^www\./, '');
  var isNew = any || !stored || (ext && !stored.utm_source && !stored.source_detail);

  if (isNew) {
    data = any ? fresh : {};
    /* landing context is captured ONCE, with the click that started the visit —
       it is the page the ad actually pointed at, not wherever they ended up. */
    data.landing_page = location.pathname + location.search;
    data.referrer = document.referrer || '';
    data.first_seen = new Date().toISOString();
    var c = classify(data.referrer, data);
    data.channel = c.channel;
    data.source_detail = c.source_detail;
    save(data);
  }
  var FIELDS = KEYS.concat(['channel', 'source_detail', 'landing_page', 'referrer', 'first_seen']);

  function fill(form) {
    if (!form || form.__twsUTM) return;
    form.__twsUTM = 1;
    FIELDS.forEach(function (k) {
      var v = data[k];
      if (!v) return;
      /* never clobber a field the form (or the app) already defines */
      if (form.querySelector('[name="' + k + '"]')) {
        var ex = form.querySelector('[name="' + k + '"]');
        if (!ex.value) ex.value = v;
        return;
      }
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = v;
      form.appendChild(i);
    });
  }

  /* ⚠⚠ `document.querySelectorAll('form')` DOES NOT SEE AN APP'S FORM.
     POWR renders into <powr-form-builder> (a custom element, its guts in a shadow
     root or an iframe); Hulk, Globo and the rest do the same. So on the live
     POWR pages there are ZERO matching <form> elements — which means the DOM
     injection finds nothing AND, before this fix, the URL bridge never fired
     either, because it was gated on having found a form. The attribution would
     have been captured perfectly and then gone nowhere.

     So the bridge triggers on any known form-app container too, not just <form>. */
  var FORMISH = 'form, powr-form-builder, [class*="powr-"], iframe[src*="powr.io"],'
              + ' .hulkapps-form, [id^="hulk"], [class*="hulk-form"],'
              + ' [class*="globo"], [data-globo-form], [class*="qikify"],'
              + ' [class*="form-builder"], iframe[src*="form"]';

  function hasFormish() {
    try { return !!document.querySelector(FORMISH); } catch (e) { return false; }
  }

  /* ⚠⚠ HULK (and apps like it) READ ONLY `utm_*` — MEASURED, 8 Aug 2026.
     Hulk renders its form in a cross-origin iframe and builds the iframe src by
     copying the PARENT page's query string. Measured on the live store: with
     `?tws_channel=social&tws_source=Instagram&utm_source=meta` on the page, the
     iframe received `utm_source=meta` and NOTHING ELSE — `tws_channel` was
     dropped. It whitelists the utm_ prefix.

     So for an app-rendered form the channel has to travel as utm_*. This does
     NOT fabricate data: for untagged traffic it writes the channel the referrer
     actually proves (an Instagram tap becomes utm_source=instagram,
     utm_medium=social), and it NEVER overwrites a real campaign the visitor
     arrived with — a tagged ad's own values always win.

     ⚠ Written with replaceState AFTER load, so analytics has already recorded
     its pageview with the original URL and no phantom session is created. */
  function bridgeUtm() {
    try {
      var u = new URL(location.href), touched = false;
      var map = { utm_source: data.utm_source, utm_medium: data.utm_medium,
                  utm_campaign: data.utm_campaign, utm_content: data.utm_content,
                  utm_term: data.utm_term };
      if (!map.utm_source && data.source_detail) {
        map.utm_source = String(data.source_detail).toLowerCase().replace(/[^a-z0-9]+/g, '-');
      }
      if (!map.utm_medium && data.channel && data.channel !== 'direct') {
        map.utm_medium = data.channel;
      }
      for (var k in map) {
        /* never clobber a real campaign already on the URL */
        if (map[k] && !u.searchParams.get(k)) { u.searchParams.set(k, map[k]); touched = true; }
      }
      if (touched) history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }

  function sweep() {
    var fs = document.querySelectorAll('form');
    for (var i = 0; i < fs.length; i++) fill(fs[i]);
    if (fs.length || hasFormish()) bridgeToUrl();
  }

  /* ── THE URL BRIDGE — the route that works with EVERY form app ─────────
     The user, 7 Aug: they do NOT want to tag every newsletter, story and post;
     the submission export must simply say where the visitor came from.

     ⚠⚠ APPENDING A HIDDEN <input> IS NOT ENOUGH ON ITS OWN. Most form apps
     render the form from their own JavaScript state and serialise THAT on
     submit, not the DOM — so an input we append can be ignored entirely, and
     it fails silently: the form submits, the field is simply absent from the
     export. Never assume the injection worked; check a real export.

     What every one of these apps DOES support is "prefill a hidden field from a
     URL parameter". So the stored attribution is also written into the current
     page's query string, and the app is configured to map those parameters onto
     hidden fields. Belt (DOM injection) and braces (URL), and at least one of
     them works on any app.

     ⚠ THE PARAMETERS ARE DELIBERATELY **NOT** CALLED utm_*. Putting utm_source
     on an internal page URL makes GA4 (and most analytics) treat it as a NEW
     campaign and start a NEW session, which would inflate sessions and
     double-count every form page. `tws_*` is ignored by analytics and read
     perfectly well by a form app.

     ⚠ replaceState, never pushState — pushState would add a history entry and
     break the Back button. It also only runs on pages that actually have a
     form, so the rest of the site keeps clean URLs. */
  var BRIDGE = {
    tws_channel: 'channel', tws_source: 'source_detail', tws_campaign: 'utm_campaign',
    tws_medium: 'utm_medium', tws_content: 'utm_content', tws_term: 'utm_term',
    tws_utm_source: 'utm_source', tws_landing: 'landing_page', tws_referrer: 'referrer'
  };
  var bridged = false;
  function bridgeToUrl() {
    if (bridged) return;
    bridged = true;
    try {
      var u = new URL(location.href), touched = false;
      for (var p in BRIDGE) {
        var v = data[BRIDGE[p]];
        if (v && !u.searchParams.get(p)) { u.searchParams.set(p, v); touched = true; }
      }
      if (touched) history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  }

  /* ⚠ THE OBSERVER IS NOT OPTIONAL. Every form app injects its form
     asynchronously, long after DOMContentLoaded — a one-shot sweep at load
     would run before the form exists and silently do nothing. */
  function start() {
    /* ⚠ BEFORE the sweep: an app iframe is built from the URL as it is at
       that instant, so the params must land first or they are simply missed. */
    bridgeUtm(); bridgeToUrl();
    sweep();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { sweep(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    /* belt and braces for apps that render inside a shadow root or swap the
       form on step change */
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.tagName === 'FORM') fill(e.target);
    }, true);
  }

  window.__twsUTM = data;
  /* readable by any app's custom-JS box: {{ }} pickers can't reach it, but a
     "custom JS" field can — e.g. Hulk's, to map values onto its own fields. */
  window.twsAttribution = function () { return data; };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
